module.exports = __webpack_public_path__ + "5e935374327894f2157cba50706c4734.svg";